import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ClientStatusSlice } from "@/lib/slices/client-status-slice";
import { createClientStatusSlice } from "@/lib/slices/client-status-slice";
import type { ClientsSlice } from "@/lib/slices/clients-slice";
import { createClientsSlice } from "@/lib/slices/clients-slice";

export type StoreSynced = ClientsSlice & ClientStatusSlice;

export const useStoreSynced = create<StoreSynced>()(
  persist(
    (...a) => ({
      ...createClientsSlice(...a),
      ...createClientStatusSlice(...a),
    }),
    {
      name: "store-synced",
      partialize: (state) => ({ id: state.id }),
    },
  ),
);
